// https://vuejs-tips.github.io/vue-the-mask/
import mask from './directive';

function install(Vue) {
	Vue.directive('mask', mask);
}

export default install;

// Install by default if included from script tag
if (typeof window !== 'undefined' && window.Vue) {
	window.Vue.use(install);
}
